import { ChangeEvent } from 'react';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';

import { CheckboxField } from '../../UIPackage/MainModule/components/CheckboxField';
import { JudgmentActionsEnum } from '../../CorePackage/CatalogsModule/enums/JudgmentActionsEnum';
import { IKnmErknmFormJudgment } from '../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormJudgment';

interface IKnmJudgmentActionsProps {
  handleChangeJudgmentAction?: (e: ChangeEvent<HTMLInputElement>) => void;
  id: string;
  isNewJudgment: boolean;
  name: string;
  value: IKnmErknmFormJudgment;
  watchOnly: boolean;
}

export const KnmJudgmentActions = ({
  handleChangeJudgmentAction,
  id,
  isNewJudgment,
  name,
  value,
  watchOnly,
}: IKnmJudgmentActionsProps) => {
  return (
    <Row id={`${id}.judgmentAction`}>
      <FieldBlock size="col-3">
        <CheckboxField
          name={`${name}.judgmentAction`}
          value={JudgmentActionsEnum.ADD_JUDGMENT}
          label={JudgmentActionsEnum.ADD_JUDGMENT}
          type="radio"
          theme="system"
          checked={value.judgmentAction === JudgmentActionsEnum.ADD_JUDGMENT}
          disabled={watchOnly || !isNewJudgment}
          onChange={handleChangeJudgmentAction}
        />
      </FieldBlock>
      <FieldBlock size="col-3">
        <CheckboxField
          name={`${name}.judgmentAction`}
          value={JudgmentActionsEnum.ANNULMENT_AKT}
          label={JudgmentActionsEnum.ANNULMENT_AKT}
          type="radio"
          theme="system"
          checked={value.judgmentAction === JudgmentActionsEnum.ANNULMENT_AKT}
          disabled={watchOnly || !isNewJudgment}
          onChange={handleChangeJudgmentAction}
        />
      </FieldBlock>
      <FieldBlock size="col-3">
        <CheckboxField
          name={`${name}.judgmentAction`}
          value={JudgmentActionsEnum.ANNULMENT_JUDGMENT}
          label={JudgmentActionsEnum.ANNULMENT_JUDGMENT}
          type="radio"
          theme="system"
          checked={value.judgmentAction === JudgmentActionsEnum.ANNULMENT_JUDGMENT}
          disabled={watchOnly || !isNewJudgment}
          onChange={handleChangeJudgmentAction}
        />
      </FieldBlock>
    </Row>
  );
};
